import { useParams } from 'react-router-dom';

import MediaCenterBlocksRenderer from 'hb-react/frontoffice/apps/MediaCenter/container/BlocksRenderer';
import { useCategories } from 'hb-react/frontoffice/apps/MediaCenter/container/hooks/useCategories';
import { useFolder } from 'hb-react/frontoffice/apps/MediaCenter/container/hooks/useFolder';
import { FOLDER_NOT_FOUND } from 'hb-react/frontoffice/apps/MediaCenter/utils/queryUtils';

const MediaCenterContainer = ({ configPage, topic }) => {
  const tags = useCategories();

  const { folderUuid } = useParams();
  const params = topic ? { folderUuid, topicId: topic.id } : { folderUuid };
  const { currentFolder, error, isLoading } = useFolder(params);

  return (
    <MediaCenterBlocksRenderer
      configPage={configPage}
      currentFolder={currentFolder}
      topic={topic}
      isFolderEmpty={error === FOLDER_NOT_FOUND}
      isLoadingCurrentFolder={isLoading}
      tags={tags}
    />
  );
};

export default MediaCenterContainer;
